import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.001, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p className={`inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.2em] ${dark ? "text-sun" : "text-ink"}`}>
    <span className="h-2 w-2 rounded-full bg-sun" aria-hidden="true" />
    {children}
  </p>
);

export const SectionTitle = ({ children, dark = false, className = "" }) => (
  <h2 className={`mt-4 font-display text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-ink"} ${className}`}>
    {children}
  </h2>
);
